/* Original name @uswitch/trustyle.usp-tag */

const UspTag = ({ usp, backgroundColor = '#E0E9FF', beforeColor = '#84A6FF', className }) => (
  <If condition={usp}>
    <div
      sx={{
        background: backgroundColor,
        textAlign: 'left',
        paddingX: 12,
        paddingY: 4,
        '::before': {
          content: '""',
          position: 'relative',
          left: '-.55em',
          borderLeft: `4px solid ${beforeColor}`,
          paddingY: '.2em',
        },
      }}
      className={className}
    >
      <span
        sx={{
          fontFamily: 'base',
          fontWeight: 'bold',
          fontSize: 'xxs',
          color: 'grey-80',
          lineHeight: 1.3,
        }}
      >
        {usp}
      </span>
    </div>
  </If>
)

export default UspTag
